import { render, staticRenderFns } from "./ReplyListAccordion.vue?vue&type=template&id=c560a130&lang=pug"
import script from "./ReplyListAccordion.vue?vue&type=script&lang=ts"
export * from "./ReplyListAccordion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports